import { useEffect, useRef } from 'react';

/**
 * Custom hook that triggers a handler function when a click is detected outside of the referenced DOM node.
 *
 * @param {Function} handler - The function to be called when a click outside the referenced element is detected.
 * @returns {Object} - A React ref object to be attached to the DOM node.
 */
const useClickOutside = (handler) => {
  const domNode = useRef();

  useEffect(() => {
    const maybeHandler = (event) => {
      if (!domNode.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener("mousedown", maybeHandler);

    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

export default useClickOutside;
